import { Model } from "pinia-orm";

export default class Testimony extends Model {
  static entity = "testimonies";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      project: this.string(""),
      meetingDate: this.string(""),
      firstName: this.string(""),
      lastName: this.string(""),
      role: this.string(""),
      company: this.string(""),
      email: this.string(""),
      telephone: this.string(""),
      siteGuide: this.boolean(false),
      transcript: this.string(""),
    };
  }
}
